
import React from 'react';
import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { FilterOperation } from '@/hooks/useConnectionData';
import { getOperationLabel } from './FilterOperationSelect';
import { formatDateRangeFilterLabel } from './dateRangeFilterUtils';

interface ActiveFilterItemProps {
  column: string;
  value: string;
  operation: FilterOperation;
  onRemove: (column: string, value: string, operation: FilterOperation) => void;
}

const ActiveFilterItem: React.FC<ActiveFilterItemProps> = ({
  column,
  value,
  operation,
  onRemove
}) => {
  return (
    <div className="flex items-center gap-1 text-sm rounded-md border px-2 py-1 bg-muted/30">
      <span className="font-medium">{column}</span>
      <span className="text-muted-foreground">{getOperationLabel(operation)}</span>
      {!['is_blank', 'is_not_blank'].includes(operation) && (
        <span>
          {operation === 'between' ? formatDateRangeFilterLabel(value) : value}
        </span>
      )}
      <Button
        variant="ghost"
        size="sm"
        className="h-4 w-4 p-0 ml-1"
        onClick={() => onRemove(column, value, operation)}
      >
        <X size={12} />
        <span className="sr-only">Remove filter</span>
      </Button>
    </div>
  );
};

export default ActiveFilterItem;
